/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 * 
 * Unauthorized copying of the code in this file, completely or partially, 
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 * 
 * Written by 'Vishal Goel' <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/


import React from "react";
import logoSrc from "./../assets/SAmaps.png";
import classes from "./Header.module.css";

// Side Drawers header with logo
const Header = () => {
  return (
    <div className={classes.Container}>
      <img src={logoSrc} className={classes.Logo} alt="ServiceActivator" />
    </div>
  );
};

export default Header;
